import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/core/services/alert.service";
import { AuthService, CurrentUser } from "src/app/core/services/auth.service";
import { SharedS } from "src/app/shared/shared-s";

@Component({
  selector: "app-nav-right",
  imports: [RouterModule, SharedS],
  templateUrl: "./nav-right.component.html",
  styleUrls: ["./nav-right.component.scss"],
})
export class NavRightComponent implements OnInit, OnDestroy {
  currentUser: CurrentUser | null = null;
  private currentUserSubscription: Subscription | undefined;

  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly alertService = inject(AlertService);

  ngOnInit(): void {
    this.currentUserSubscription = this.authService.currentUser$.subscribe(
      (user) => {
        this.currentUser = user;
      },
    );
  }

  ngOnDestroy(): void {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }

  onLogout(): void {
    //console.log(' Iniciando cierre de sesión...');
    this.alertService
      .mostrarConfirmacion(
        "¿Está seguro que desea cerrar sesión?",
        "Cerrar sesión",
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.executeLogout();
        }
      });
  }

  /* Ejecuta el cierre de sesión   */
  private executeLogout(): void {
    this.authService.logout();
    this.alertService.toastInfo("Sesión cerrada correctamente");
    this.router.navigate(["/authentication/login"]);
  }
}
